/*
 *
 * SummaryQuestions constants
 *
 */
const routeComponent = "app/Reports/components/SummaryQuestions"

export const GET_LIST_COUNT_QUESTIONS_WATCHER = `${routeComponent}/GET_LIST_COUNT_QUESTIONS_WATCHER`
export const GET_LIST_COUNT_QUESTIONS_SUCCESS = `${routeComponent}/GET_LIST_COUNT_QUESTIONS_SUCCESS`
export const GET_LIST_COUNT_QUESTIONS_FAILED = `${routeComponent}/GET_LIST_COUNT_QUESTIONS_FAILED`
